import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { getUserAvatar } from '../../../../../../utils/user'
import { Avatar, AVATAR_HEIGHT_32 } from '../../../../../Avatar'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import { STATUS_SIZE_20 } from '../../../../../Status'
import Text from '../../../../../Text'
import { getUserLabel, UserStatusTag } from '../../../../../User'
import { QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_ADD_SUGGESTION_BTN } from '../../DocFlowMappingRecipientModal.constants'

import * as styles from './DocFlowMappingRecipientModalSuggestionsItem.module.css'

import PlusIcon from '../../../../../../icons/plus.svg'

function DocFlowMappingRecipientModalSuggestionsItem({
  disabled,
  item,
  onAdd,
}) {
  const { t } = useTranslation()

  function handleClickAdd() {
    onAdd(item)
  }

  return (
    <div className={styles.DocFlowMappingRecipientModalSuggestionsItem}>
      <Avatar {...getUserAvatar(item)} size={AVATAR_HEIGHT_32} />
      <div className={styles.info}>
        <Text className={styles.name}>{getUserLabel(item)}</Text>
        <UserStatusTag height={STATUS_SIZE_20} value={item.status} />
      </div>
      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: PlusIcon }}
        disabled={disabled}
        height={BUTTON_HEIGHT_32}
        qaName={QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_ADD_SUGGESTION_BTN}
        tooltip={t('Modal.AddBtnKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={handleClickAdd}
      />
    </div>
  )
}

export default DocFlowMappingRecipientModalSuggestionsItem
